import React from "react";

const CorprateTraining = () => {
  return (
    <>
      <div className="LegalsPage">
        <div className="terms">
          <h3>Corporate Training</h3>
        </div>
      </div>
    </>
  );
};

export default CorprateTraining;
